const SuperAdminBannerEndPoint = {
  getBannerList: {
    url: "/banner",
    method: "GET",
  },
  addBanner: {
    url: "/banner",
    method: "POST",
  },
  updateBanner: (id) => ({
    url: `/banner/${id}`,
    method: "PUT",
  }),
  updateBannerStatus: (id) => ({
    url: `/banner-status/${id}`,
    method: "PATCH",
  }),
  deleteBanner: (id) => ({
    url: `/banner/${id}`,
    method: "DELETE",
  }),
};

export default SuperAdminBannerEndPoint;
